export const LOADING = "LOADING";
export const MIC_OPEN = "MIC_OPEN";
export const HISTORY_CHAT = "HISTORY_CHAT";
